// import router from '@/app/router';
//
// const goBack = (route) => {
//   router.push({
//     name: 'dashboard',
//     query: route.query
//   });
// };

export default {
  default: {
    component: () => import(/* webpackChunkName: 'dashboard/dashboard' */ './WrDashboard'),
    routes: [
      {
        path: '',
        name: 'wr-dashboard',
        component: () => import(/* webpackChunkName: 'dashboard/dashboardMain' */ './components/DashboardMain')
      }
    ]
  }
};
